module.exports = __webpack_public_path__ + "static/logo_light_2-1-768x512-2921ae1cf002d323337c948c08ea4f7b.jpg";